import { getRouteApi } from "@tanstack/react-router";
import { Fragment, useRef } from "react";
import { LotsTable } from "../LotsTable";
import { BenchmarkFilters } from "@/benchmarks/BenchmarkFilters";
import { ExportLotsButton } from "@/components/AsyncJobMenu/components/ExportLotsButton";
import { PageHeader } from "@/components/PageHeader";
import { type ResetPagination } from "@/components/Pagination/usePagination";

const routeApi = getRouteApi("/(authed)/_layout/benchmarks");

export function Benchmarks() {
  const openTableRef = useRef<{ resetPagination: ResetPagination }>(null);
  const closedTableRef = useRef<{ resetPagination: ResetPagination }>(null);
  const filters = routeApi.useSearch();

  const handleResetPagination = () => {
    openTableRef.current?.resetPagination();
    closedTableRef.current?.resetPagination();
  };

  return (
    <Fragment>
      <PageHeader>
        <PageHeader.Content>
          <PageHeader.Title>Benchmarks</PageHeader.Title>
        </PageHeader.Content>
        <PageHeader.Actions>
          <ExportLotsButton filters={filters} />
        </PageHeader.Actions>
      </PageHeader>
      <BenchmarkFilters handleResetPagination={handleResetPagination} />
      <LotsTable tableId="closedLotsTable" status="CLOSED" ref={closedTableRef} filters={filters} />
      <LotsTable tableId="openLotsTable" status="OPEN" ref={openTableRef} filters={filters} />
    </Fragment>
  );
}
